// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sidebar":"HomeLayout-5cf9cc7db30e59d8","results-filters-wrapper":"HomeLayout-ab68807c679c84f0","content":"HomeLayout-b45e85df675abd0e"};